import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { X, Plus } from "lucide-react";

interface TrackingNumberInputProps {
  trackingNumbers: string[];
  onChange: (numbers: string[]) => void;
}

export const TrackingNumberInput = ({ trackingNumbers, onChange }: TrackingNumberInputProps) => {
  const addTrackingNumber = () => {
    onChange([...trackingNumbers, ""]);
  };

  const removeTrackingNumber = (index: number) => {
    const newNumbers = trackingNumbers.filter((_, i) => i !== index);
    onChange(newNumbers);
  };

  const updateTrackingNumber = (index: number, value: string) => {
    const newNumbers = [...trackingNumbers];
    newNumbers[index] = value;
    onChange(newNumbers);
  };

  return (
    <div className="space-y-2">
      {trackingNumbers.map((number, index) => (
        <div key={index} className="flex gap-2">
          <Input
            value={number}
            onChange={(e) => updateTrackingNumber(index, e.target.value)}
            placeholder="Enter tracking number"
            className="flex-1"
          />
          {trackingNumbers.length > 1 && (
            <Button
              type="button"
              variant="ghost"
              size="icon"
              onClick={() => removeTrackingNumber(index)}
            >
              <X className="h-4 w-4" />
            </Button>
          )}
        </div>
      ))}
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={addTrackingNumber}
        className="w-full"
      >
        <Plus className="h-4 w-4 mr-2" />
        Add another tracking number
      </Button>
    </div>
  );
};
